import React from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
// import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
// import './styles.css';

const useStyles = makeStyles((theme) => ({
    question: {
        color: '#111',
        fontFamily: 'Rubik',
        fontSize: '15px',
        fontWeight: 500,
    },
    subheading: {
        fontSize: '12px',
        color: '#4c4c4d',
        fontFamily: 'Rubik',
        fontWeight: 500,
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

const OtherClauses3cd = () => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        name: '',
        pan: '',
        value: '',
    });

    return (
        <Grid container spacing={3} className="main-container">
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Determine if there are any adjustments to be done as per ICDS</Typography>
                {/* <Typography className={classes.subheading}></Typography> */}
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Carry the disclosures in clause 13(e) & 13(f) relating to ICDS</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    List all the credits to capital account, which are in the nature of income and not routed through P&L in clause 16
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Enlist the additions and deletions to Fixed assets during the year. Reconcile the same with books of accounts
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Compute Depreciation allowable as per IT Act</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Verify the cash book to see if there are any payments to creditors in excess of Rs.10,000 in cash
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    If there are payments towards revenue expenses to related parties, enlist the same and report in clause 23 of Form 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    In case if the client is Firm or LLP, compute allowable remuneration and interest on capital. Report it in clause 21(c)
                    of 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    If there are unfunded gratuities, report on its payment particulars in clause 21(e)
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Verify the P&L account to see if there are fine, penalties, capital expenditures, prior period expenses, personal
                    expenses - Report in clause 21(a) of 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    In case of sale of immovable property during the year, whether the sale value is different from fair value, if yes,
                    report in clause 17 of 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Verify the previous year return, 143(1) and 143(3) order, if any to determine the brought forward loss to be reported in
                    32(a) of 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    In case of company, see if the share holding has changed beyond 51% and report in clause 32(b)
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Verify if there are any payments allowable as deductions under Chapter VIA and report in clause 33 of 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>In case there is DDT paid, report it in clause 36 of 3CD</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Details regarding comparative ratios of sales/services to be reported in clause 40 of 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    In case there are IDT assessments, obtain copies of orders and report the details in clause 41 of 3CD
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Verify whether any loan or deposit has been taken or accepted in cash during the year of a sum exceeding Rs. 20,000, if
                    yes provide the required details as laid out in clause 31 u/s 269SS and 269T
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Verify whether any amount has been taken or accepted in cash during the year of a sum exceeding Rs. 2,00,000, if yes
                    provide the required details as laid out in clause 31 u/s 269ST
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>MAT and AMT Applicability on Client</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Verify on Change In Shareholding and Profit Sharging ratio</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
        </Grid>
    );
};

export default OtherClauses3cd;
